import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Filters from '@/filters'
import FastClick from 'fastclick'
import '@/assets/js/utils/validator' //表单校验
import Jump from '@/assets/js/utils/jump'
import utils from '@/assets/js/business-common'
// import EbizTrack from '@/assets/js/utils/ebizTrack.es.js'
import config from '@/config'
import noMoreClick from '@/directive/noMoreClick'

import axios from 'axios'
import '@/assets/fonts/iconfont.css'
import VueClipboard from 'vue-clipboards'
Vue.prototype.$axios = axios
//全局注册vant常用组件
import { Toast, Button, Dialog, Icon } from 'vant'
import { TrackStart, TrackStop, TrackText, appendAnnexes } from '@/assets/js/utils/track.js'
// import { Table } from 'view-design'
// Vue.component('Table', Table)
import 'view-design/dist/styles/iview.css'
Vue.use(Icon)
// eruda.init()
Vue.use(Toast)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(VueClipboard)
// Vue.use(TrackStart)
// Vue.use(TrackStop)
// Vue.use(TrackText)
Vue.prototype.$TrackStart = TrackStart
Vue.prototype.$TrackStop = TrackStop
Vue.prototype.$TrackText = TrackText
Vue.prototype.$appendAnnexes = appendAnnexes

let globalVariableStorage = localStorage.getItem('globalVariable')
let globalVariable = globalVariableStorage ? JSON.parse(globalVariableStorage) : []
Vue.prototype.$globalVariable = globalVariable

let activeIndexStorage = localStorage.getItem('activeIndex')
let activeIndex = activeIndexStorage ? activeIndexStorage : ''
Vue.prototype.$activeIndex = activeIndex

let treeSelectDataStorage = localStorage.getItem('treeSelectData')
let treeSelectData = treeSelectDataStorage ? JSON.parse(treeSelectDataStorage) : []
Vue.prototype.$treeSelectData = treeSelectData

let scrollDOMTopStorage = localStorage.getItem('scrollDOMTop')
let scrollDOMTop = scrollDOMTopStorage ? scrollDOMTopStorage : 0
Vue.prototype.$scrollDOMTop = scrollDOMTop

Vue.prototype.$assetsUrl = config.assetsUrl
Vue.prototype.$mainUrl = config.mainUrl
// 全局 防重复点击
Vue.directive('no-more-click', noMoreClick)
//解决ios移动端input调软键盘问题
let isIphone = navigator.userAgent.indexOf('iPhone') != -1
if (isIphone) {
  FastClick.prototype.focus = function (targetElement) {
    let length
    if (
      isIphone &&
      targetElement.setSelectionRange &&
      targetElement.type.indexOf('date') !== 0 &&
      targetElement.type !== 'time' &&
      targetElement.type !== 'month' &&
      targetElement.type !== 'email' &&
      targetElement.type !== 'number'
    ) {
      length = targetElement.value.length
      targetElement.setSelectionRange(length, length)
      /*修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘*/
      targetElement.focus()
    } else {
      targetElement.focus()
    }
  }
}
// PC端企业微信内置浏览器window下有ontouchstart。导致内部判定用touch滑动
// 通过判断window有无ontouchstart属性来控制picker用鼠标滑动还是用touch滑动
// if (~navigator.userAgent.toLowerCase().indexOf('windowswechat')) {
//   delete window.ontouchstart
// }

// let sUserAgent= navigator.userAgent.toLowerCase(); 
// let bIsIpad= sUserAgent.match(/ipad/i) == "ipad"; 
// let bIsIphoneOs= sUserAgent.match(/iphone os/i) == "iphone os"; 
// let bIsMidp= sUserAgent.match(/midp/i) == "midp"; 
// let bIsUc7= sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4"; 
// let bIsUc= sUserAgent.match(/ucweb/i) == "ucweb"; 
// let bIsAndroid= sUserAgent.match(/android/i) == "android"; 
// let bIsCE= sUserAgent.match(/windows ce/i) == "windows ce"; 
// let bIsWM= sUserAgent.match(/windows mobile/i) == "windows mobile"; 

// if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) { 
//   alert("您是手机登陆");
// } else { 
//   alert("您是电脑登陆");
// } 

//router or bridge jump
Vue.prototype.$jump = Jump

Vue.prototype.$utils = utils
// 可回溯
// Vue.prototype.$EbizTrack = EbizTrack

//混合开发调试工具
if (process.env.VUE_APP_FLAG != 'prd') {
  // let Eruda = require('eruda')
  eruda.init()
  // Vue.prototype.$rootUrl = location.origin
  Vue.config.devtools = true
} else {
  // eruda.init()
  //预留配置域名有子目录情况
  // Vue.prototype.$rootUrl = location.origin + '/ebiz-h5'
  Vue.config.devtools = false
}
// 注册过滤器
Object.keys(Filters).forEach(function (k) {
  Vue.filter(k, Filters[k])
})

//权限控制
import { permission } from '@/assets/js/utils/permission'
permission()

//ios点击300毫秒时延
FastClick.attach(document.body)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
